export enum NotificationAreaType {
  Alarms = 'Alarms', // Larmbevakning
  Access = 'Access', // Behörighet
  Messages = 'Messages',
  Contracts = 'Contracts', // Avtal
  Invoices = 'Invoices', // Fakturaavisering
  PaymentReminder = 'PaymentReminder', // Betalningspåminnelse,
  ReturnTemp = 'ReturnTemp', // ReturTemp Hög/Låg
  Account = 'Account', // Kontoaktivitet
  Consumption = 'Consumption', // Förbrukning
  FunctionControl = 'FunctionControl', // Funktionskontroll
}
